<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>
    <section class="bg-home bg-circle-gradiant d-flex align-items-center">
      <div class="bg-overlay bg-overlay-white"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-8">
            <div class="card login_page shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center">
                  {{ $t("auth:reset_password.text") }}
                </h4>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    class="login-form mt-4"
                    @submit.prevent="handleSubmit(resetPassword)"
                  >
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <ValidationProvider
                            name="password"
                            rules="required|mandaa-password|password:@confirm"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:reset_password.password") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <key-icon class="fea icon-sm icons"></key-icon>
                              <input
                                v-model="user.password"
                                type="password"
                                class="form-control pl-5"
                                :placeholder="
                                  $t('auth:reset_password.password')
                                "
                                name="password"
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': failed }
                                ]"
                              />
                              <span
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(errors[0]) }}</span
                              >
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="form-group">
                          <ValidationProvider
                            name="confirm"
                            rules="required|mandaa-password|"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:reset_password.confirm_password") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <key-icon class="fea icon-sm icons"></key-icon>
                              <input
                                v-model="user.confirmPassword"
                                type="password"
                                class="form-control pl-5"
                                :placeholder="
                                  $t('auth:reset_password.confirm_password')
                                "
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': failed }
                                ]"
                              />
                              <span
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(errors[0]) }}</span
                              >
                              <span
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(msg) }}</span
                              >
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="col-lg-12 mb-0">
                        <base-button native-type="submit" type="primary" block>
                          {{ $t("auth:reset_password.text") }}
                        </base-button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { HomeIcon, KeyIcon } from "vue-feather-icons";
import HttpClientFactory from "../services/HttpClientFactory";

export default {
  name: "ForgotPassword",
  components: {
    HomeIcon,
    KeyIcon
  },
  data() {
    return {
      user: {
        password: "",
        confirmPassword: ""
      },
      msg: ""
    };
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
  },
  methods: {
    resetPassword() {
      const sendData = {
        token: this.$route.query.token,
        password: this.user.password
      };
      this.httpClient
        .patch(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/reset-password",
          sendData
        )
        .then(() => {
          this.$notify({
            text: this.$t("auth:reset_password.success"),
            type: "success"
          });
          setTimeout(() => this.$router.push("login"), 2000);
        })
        .catch(() => {
          this.msg = "auth:reset_password.error";
        });
    }
  }
};
</script>
